export function ComponentFancySlider() {
  function resetImageBox(element) {
    element.removeAttr('style');
    element.css('background-color', $(element).data('background-color'));
  }

  function resizeImages() {
    var imageHeight = $('.fancy-slider .image').height();
    $('.fancy-slider .image img').height(imageHeight);
  }

  $(window).on('resize', resizeImages);
  resizeImages();

  var currentStepIndex = 0;
  $('.fancy-slider .indicators a').on('click', function(e) {
    e.preventDefault();

    var index = $(this).index();
    switchToImage(index);
  });

  $('.fancy-slider .texts, .fancy-slider .indicators').on('mouseenter', function() {
    stopFancyGallery();
  }).on('mouseleave', function() {
    startFancyGallery();
  });

  var fancyGalleryInterval;
  function startFancyGallery() {
    stopFancyGallery();

    fancyGalleryInterval =  setInterval(function() {
      var index = (currentStepIndex + 1) % $('.fancy-slider .slide').length;

      switchToImage(index);
    }, 50000000);
  }

  function stopFancyGallery() {
    clearInterval(fancyGalleryInterval);
  }

  function switchToImage(index) {
    if (index == currentStepIndex) return;

    $('.fancy-slider .indicators a').removeClass('active');
    $($('.fancy-slider .indicators a').get(index)).addClass('active');

    var nextStep = $($('.fancy-slider .slide').get(index));
    var nextImageBox = nextStep.find('.image');
    var nextImage = nextStep.find('img');
    var nextText = nextStep.find('.texts');

    var currentStep = $($('.fancy-slider .slide').get(currentStepIndex));
    var currentImageBox = currentStep.find('.image');
    var currentImage = currentStep.find('img');
    var currentText = currentStep.find('.texts');

    //reset the currentImageBox
    resetImageBox(nextImageBox);

    //Show next step invisible
    nextStep.show();
    nextText.removeClass('fade-out').addClass('fade-in')

    //Morph image box
    currentImageBox.css({
      width: currentImage.width(),
      height: currentImage.height(),
      left: currentImageBox.position().left,
      right: 'auto'
    })

    currentImage.addClass('fade-out');
    currentText.addClass('fade-out');

    setTimeout(function() {
      currentImageBox.css({
        width: nextImage.width(),
        height: nextImage.height(),
        left: nextImageBox.position().left ,
        backgroundColor: nextImageBox.css('background-color')
      });
    }, 750);

    setTimeout(function() {
      currentStep.removeClass('current').hide();
      nextStep.addClass('current');
      currentImage.removeClass('fade-out');
      nextText.removeClass('fade-in');
    }, 1500);

    currentStepIndex = index;
  }

  if ($('.fancy-slider').length > 0) startFancyGallery();
}
